import { Component, OnInit } from '@angular/core';
import { Account } from '../models/account';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { FieldCustomizationService } from '../services/field-customization/field-customization.service';
import { CustomFieldConfig } from '../models/customfieldconfig';
import { ServiceProviderService } from '../services/service-provider/service-provider.service';

@Component({
  selector: 'app-export-excel',
  templateUrl: './export-excel.component.html',
  styleUrls: ['./export-excel.component.css']
})
export class ExportExcelComponent implements OnInit {

  foruscareService: ForuscareService;
  accounts: Account[];
  accountId = null;
  dropdownSettings: any = {};
  // customFieldConfig: CustomFieldConfig;
  patientFields: CustomFieldConfig;
  medicalInfoFields: CustomFieldConfig;
  refractionFields: CustomFieldConfig;
  allPatientRegistrationSelected = false;
  allMedicalInfoFieldSelected = false;
  allRefractionFieldsSelected = false;
  allModules = [{ id: 'patient-registration', itemName: 'Patient' }, { id: 'medical-info', itemName: 'Medical Info' }, { id: 'refraction', itemName: 'Refraction' }];
  selectedModules = [];
  allModulesStatus = { "patient-registration": false, "medical-info": false, "refraction": false };
  downloadExcelData = {};

  constructor(public fieldCustomizationService: FieldCustomizationService, public accountService: AccountService, public serviceProviderService: ServiceProviderService) {
    this.foruscareService = new ForuscareService();
    this.patientFields = new CustomFieldConfig();
    this.patientFields.customFields = [];
    this.patientFields.sections = [];
    this.medicalInfoFields = new CustomFieldConfig();
    this.medicalInfoFields.customFields = [];
    this.medicalInfoFields.sections = [];
    this.refractionFields = new CustomFieldConfig();
    this.refractionFields.customFields = [];
    this.refractionFields.sections = [];
  }

  ngOnInit(): void {
    this.getAvailableAccounts();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  // Get all account list 
  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  // Get custom fields and sections associated with account
  getCustomFieldsByAccountId() {

    if (!this.allModulesStatus['patient-registration'] && !this.allModulesStatus['medical-info'] && !this.allModulesStatus['refraction']) {
      this.foruscareService.showNotification("Please select atleast one module", "danger");
      return;
    }

    if ((this.accountId != null && this.accountId > 0)) {
      this.patientFields.customFields = [];
      this.patientFields.sections = [];
      this.medicalInfoFields.customFields = [];
      this.medicalInfoFields.sections = [];
      this.refractionFields.customFields = [];
      this.refractionFields.sections = [];

      if (this.allModulesStatus['patient-registration']) {
        this.fieldCustomizationService.getAllFieldsByAccountIdAndModule(this.accountId, "Patient", null, null).subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {

              // this.customFieldConfig = response.data;
              // this.allCustomFieldAndSection.push(response.data);
              this.patientFields = response.data;
              this.patientFields.customFields.forEach(element => {
                if (element.isMandatory) {
                  element['isSelected'] = true;
                } else {
                  element['isSelected'] = false;
                }
              });
              if (this.patientFields.sections.length > 0) {
                this.patientFields.sections.forEach(element => {
                  element.customFields.forEach(field => {
                    if (field.isMandatory) {
                      field['isSelected'] = true;
                    } else {
                      field['isSelected'] = false;
                    }
                  });
                });
              }
              console.log(this.patientFields);
            }
            else {
              //this.FieldCustomizationList=[];
              //this.FieldCustomizationList.push(new CustomField(this.accountId,true,this.moduleId));

            }
            // this.disableButton();
          }
          else {
            //this.foruscareService.showNotification(response.message, "danger");
          }
        });
      }
      if (this.allModulesStatus['medical-info']) {
        this.fieldCustomizationService.getAllFieldsByAccountIdAndModule(this.accountId, "Medical Info", null, null).subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {

              // this.customFieldConfig = response.data;
              // this.allCustomFieldAndSection.push(response.data);
              this.medicalInfoFields = response.data;
              this.medicalInfoFields.customFields.forEach(element => {
                if (element.isMandatory) {
                  element['isSelected'] = true;
                } else {
                  element['isSelected'] = false;
                }
              });
              if (this.medicalInfoFields.sections.length > 0) {
                this.medicalInfoFields.sections.forEach(element => {
                  element.customFields.forEach(field => {
                    if (field.isMandatory) {
                      field['isSelected'] = true;
                    } else {
                      field['isSelected'] = false;
                    }
                  });
                });
              }
              console.log(this.medicalInfoFields);
            }
            else {
              //this.FieldCustomizationList=[];
              //this.FieldCustomizationList.push(new CustomField(this.accountId,true,this.moduleId));

            }
            // this.disableButton();
          }
          else {
            //this.foruscareService.showNotification(response.message, "danger");
          }
        });
      }
      if (this.allModulesStatus['refraction']) {
        this.fieldCustomizationService.getAllFieldsByAccountIdAndModule(this.accountId, "REFRACTION", null, null).subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {

              // this.customFieldConfig = response.data;
              // this.allCustomFieldAndSection.push(response.data);
              this.refractionFields = response.data;
              this.refractionFields.customFields.forEach(element => {
                if (element.isMandatory) {
                  element['isSelected'] = true;
                } else {
                  element['isSelected'] = false;
                }
              });
              if (this.refractionFields.sections.length > 0) {
                this.refractionFields.sections.forEach(element => {
                  element.customFields.forEach(field => {
                    if (field.isMandatory) {
                      field['isSelected'] = true;
                    } else {
                      field['isSelected'] = false;
                    }
                  });
                });
              }

              console.log(this.refractionFields);
            }
            else {
              //this.FieldCustomizationList=[];
              //this.FieldCustomizationList.push(new CustomField(this.accountId,true,this.moduleId));

            }
            // this.disableButton();
          }
          else {
            //this.foruscareService.showNotification(response.message, "danger");
          }
        });
      }
    }

  }

  selectAllFields(section: String) {
    switch (section) {
      case 'patient-registration': {
        if (this.allPatientRegistrationSelected) {
          this.patientFields.customFields.forEach(element => {
            element['isSelected'] = true;
          });
          if (this.patientFields.sections.length > 0) {
            this.patientFields.sections.forEach(element => {
              element.customFields.forEach(field => {
                field['isSelected'] = true;
              });
            });
          }
        } else {
          this.patientFields.customFields.forEach(element => {
            if (element.isMandatory) {
              element['isSelected'] = true;
            } else {
              element['isSelected'] = false;
            }
          });
          if (this.patientFields.sections.length > 0) {
            this.patientFields.sections.forEach(element => {
              element.customFields.forEach(field => {
                if (field.isMandatory) {
                  field['isSelected'] = true;
                } else {
                  field['isSelected'] = false;
                }
              });
            });
          }
        }
        break;
      };
      case 'medical-info': {
        if (this.allMedicalInfoFieldSelected) {
          this.medicalInfoFields.customFields.forEach(element => {
            element['isSelected'] = true;
          });
          if (this.medicalInfoFields.sections.length > 0) {
            this.medicalInfoFields.sections.forEach(element => {
              element.customFields.forEach(field => {
                field['isSelected'] = true;
              });
            });
          }
        } else {
          this.medicalInfoFields.customFields.forEach(element => {
            if (element.isMandatory) {
              element['isSelected'] = true;
            } else {
              element['isSelected'] = false;
            }
          });
          if (this.medicalInfoFields.sections.length > 0) {
            this.medicalInfoFields.sections.forEach(element => {
              element.customFields.forEach(field => {
                if (field.isMandatory) {
                  field['isSelected'] = true;
                } else {
                  field['isSelected'] = false;
                }
              });
            });
          }
        }
        break;
      };
      case 'refraction': {
        if (this.allRefractionFieldsSelected) {
          this.refractionFields.customFields.forEach(element => {
            element['isSelected'] = true;
          });
          if (this.refractionFields.sections.length > 0) {
            this.refractionFields.sections.forEach(element => {
              element.customFields.forEach(field => {
                field['isSelected'] = true;
              });
            });
          }
        } else {
          this.refractionFields.customFields.forEach(element => {
            if (element.isMandatory) {
              element['isSelected'] = true;
            } else {
              element['isSelected'] = false;
            }
          });
          if (this.refractionFields.sections.length > 0) {
            this.refractionFields.sections.forEach(element => {
              element.customFields.forEach(field => {
                if (field.isMandatory) {
                  field['isSelected'] = true;
                } else {
                  field['isSelected'] = false;
                }
              });
            });
          }
        }
      }
    }

  }

  onModuleChange(event, status) {
    console.log("Event ==> ", event);
    switch (status) {
      case 'ADD': {
        this.allModulesStatus[event.id] = true;
        break;
      };
      case 'REMOVE': {
        this.allModulesStatus[event.id] = false;
        break;
      }
      case 'ADD_ALL': {
        event.forEach(module => {
          this.allModulesStatus[module.id] = true;
        });
        break;

      };
      case 'REMOVE_ALL': {
        for (let module in this.allModulesStatus) {
          this.allModulesStatus[module] = false;
        }
        break;
      }
    }
    console.log("THis Modeule ===> ", this.allModulesStatus);
  }

  downloadExcel() {
    console.log("Patient ==> ", this.patientFields);
    // console.log("Medical ==> ", this.medicalInfoFields);
    // console.log("Refraction ==> ", this.refractionFields);
    this.downloadExcelData = {};
    if (this.allModulesStatus['patient-registration']) {
      let patientFields = {};
      patientFields["staticColumns"] = ["MRN", "Patient Created Time"];
      patientFields["columns"] = []
      this.patientFields.customFields.forEach(element => {
        if (element["isSelected"]) {
          patientFields["columns"].push({ "fieldId": element.id, "fieldName": element.fieldName, "module": "Patient" })
        }
      });
      this.patientFields.sections.forEach(element => {
        element.customFields.forEach(field => {
          if (element["isSelected"]) {
            patientFields["columns"].push({ "fieldId": field.id, "fieldName": field.fieldName, "module": "Patient" })
          }
        });
      });
      this.downloadExcelData["patient"] = patientFields;
    }

    if (this.allModulesStatus['medical-info']) {
      let medicalFields = {};
      medicalFields["staticColumns"] = ["MRN","Visit Created Time"];
      medicalFields["columns"] = []
      this.medicalInfoFields.customFields.forEach(element => {
        if (element["isSelected"]) {
          medicalFields["columns"].push({ "fieldId": element.id, "fieldName": element.fieldName, "module": "Medical Info" })
        }
      });
      this.medicalInfoFields.sections.forEach(element => {
        element.customFields.forEach(field => {
          if (field["isSelected"]) {
            medicalFields["columns"].push({ "fieldId": field.id, "fieldName": field.fieldName, "module": "Medical Info" })
          }
        });
      });
      this.downloadExcelData["Medical Info"] = medicalFields;
    }
    if (this.allModulesStatus['refraction']) {
      let refractionSelectedFields = {};
      refractionSelectedFields["staticColumns"] = ["MRN","Objective Refraction", "Subjective Refraction", "Refraction Created Time"];
      refractionSelectedFields["columns"] = []
      this.refractionFields.customFields.forEach(element => {
        if (element["isSelected"]) {
          refractionSelectedFields["columns"].push({ "fieldId": element.id, "fieldName": element.fieldName, "module": "Refraction" })
        }
      });
      this.refractionFields.sections.forEach(element => {
        element.customFields.forEach(field => {
          if (field["isSelected"]) {
            refractionSelectedFields["columns"].push({ "fieldId": field.id, "fieldName": field.fieldName, "module": "Refraction" })
          }
        });
      });
      this.downloadExcelData["Refraction"] = refractionSelectedFields;
    }

    this.accountService.generateExcelForImport(this.accountId, this.downloadExcelData).subscribe(response => {
      if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
        console.log("Download Excel ===> ", response);
        this.serviceProviderService.getBlobURLtobase64(response.data.blobPath).subscribe(response2 => {
          if (response.errorCode == 200) {
            console.log("Response ===>",response2);
            var link = document.createElement("a");
            link.style.display = "none";
            link.download = response.data.fileName;
            link.href = 'data:application/octet-stream;base64,' + response2.data;
            document.body.appendChild(link);
            link.click();
            this.foruscareService.showNotification("Downloading "+ response.data.fileName, "success");
          }else{
            this.foruscareService.showNotification(response.errorCode + " Something went wrong!", "danger");
          }
        });
        // let blob = new Blob([response.body], { type: 'application/octet-stream'});
        // var link = document.createElement('a');
        // link.style.display = "none";
        // link.href = window.URL.createObjectURL(blob);
        // link.download = 'offline_payment_report.xlsx';
        // link.click();
      }
    });
    console.log("Donwload Excel Payload", this.downloadExcelData);
  }

  // Prevent deselection if it's mandatory
  preventDeselect(event: Event, itr: any) {
    if (itr.isMandatory && itr.isSelected) {
      this.foruscareService.showNotification("Cannot unselect the mandatory fields", "danger");
      event.preventDefault(); 

    }
  }

}
